import React from "react";
import ReactPlayer from "react-player";
import { createElementClass, createModifierClass } from "../../helpers";
export var embedVideoParser = function embedVideoParser(args) {
  return {
    replaceChildren: true,
    shouldProcessNode: function shouldProcessNode(node) {
      return node.type === "tag" && node.name === "div" && node.attribs && node.attribs.hasOwnProperty("video-link") && node.attribs.hasOwnProperty("video-type");
    },
    processNode: function processNode(node) {
      var type = node.attribs["video-type"];
      var url = node.attribs["video-link"];

      if (!type || !url) {
        return null;
      }

      return React.createElement(ReactPlayer, {
        className: createElementClass("video") + " " + createModifierClass(type, "video"),
        url: url
      });
    }
  };
};